<template>
  <div>
  <vue-headful title="Alabama Travel - Most Relaxing Trip Ever" description="Alabama Travel - Contest" url="https://alabama.travel/most-relaxing-trip" />
  <figure class="banner-image">
    <img :src="page.fields.header_image" :alt="page.fields.header_image_alt_text">
  <div class='banner-logo'><img :src="mrte.bannerLogo" :alt="page.fields.image_alt_text" role='presentation'/></div>
  </figure>
  <section>
    <div class='container intro'>
      <div class='row'>
        <div class='col-lg-12 mt-5'>
          <h1 class='headline'>{{ mrte.headline }}</h1>
          <div v-html="mrte.description" class='description mt-3'></div>
          <a href="#requirements" class='description-link' v-on:click="expand">The Nitty Gritty</a>
        </div>
      </div>
    </div>
  </section>
  <section>
    <div class="container trip-home-detail">
      <div class="row trip-details bg-arrow">
        <div class="col-md-4 col-lg-6">
          <div class=''>
            <div class='foot-step'></div>
            <img :src="mrte.backgroundImage" class="bg-image" :alt="page.fields.background_image_alt_text" role="presentation" />
            <div class="logo">
              <a v-if="mrte.logoLeftLink.includes('http')" :href="mrte.logoLeftLink"   :aria-label="`${mrte.altDescLogoLeft} opens in a new window`"  rel='noopener' target='_blank' class=""><img :src="mrte.logoLeft" class="logo-left" /></a>
              <a  v-else :href="mrte.logoLeftLink" class="block-button"><img :src="mrte.logoLeft" :alt="page.fields.alt_text_logo_left" class="logo-left" /></a>
              <a v-if="mrte.logoRightLink.includes('http')" :href="mrte.logoRightLink"  :aria-label="`${mrte.altDescLogoRight} opens in a new window`"  rel='noopener' target='_blank' class=""><img :src="mrte.logoRight" class="logo-right" /></a>
              <a  v-else :href="mrte.logoRightLink" class="block-button"><img :src="mrte.logoRight" :alt="page.fields.alt_text_logo_left1" class="logo-right" /></a>
            </div>
            <div class='boot-step'></div>
          </div>
        </div>
        <div class="col-md-8 col-lg-6 text-left">
          <h2 class='block-title'>{{ mrte.block1Title }}</h2>
          <div class='block-desc' v-html="mrte.block1Desc"></div>
          <div class='block-desc-2' v-html="mrte.block1Desc2"></div>
          <ul class='icons'>
            <li class="icon-box" v-for="(icon, index) in mrte.tripIcons" :key="index">
              <img class='image-icon' :src="icon.image" :alt="icon.image_alt_text" />
              <div class='caption-icon'>{{ icon.caption }}</div>
            </li>
          </ul>
        </div>
      </div>
      <div class='home-details-arrow-1'></div>
      <div class='row home-details'>
        <div class="col-md-8 col-lg-6 text-left">
          <h2 class='block-title hd-block-title'>{{ mrte.block2Title }}</h2>
          <div class='block-desc' v-html="mrte.block2Desc"></div>
          <ul class='icons'>
            <li class="icon-box" v-for="(icon, index) in mrte.homeIcons" :key="index">
              <img class='image-icon' :src="icon.image" :alt="icon.image_alt_text" />
              <div class='caption-icon'>{{ icon.caption }}</div>
            </li>
          </ul>
        </div>
        <div class='home-details-arrow-2'></div>
        <div class='col-md-4 col-lg-6'>
          <img class='desktop' :src="mrte.block2Image" :alt="page.fields.block_2_image_alt_text" />
        </div>
      </div>
    </div>
  </section>
  <section>
    <div class="instagram-section">
      <div class="row instagram">
        <div class="col-lg-6">
          <div class="video-div">
            <video autoplay muted playsinline loop src="https://alabama-travel.s3.amazonaws.com/videos/ATD_MRTE_Loop.mp4" type="video/mp4" class="video img-fluid" />
          </div>
        </div>
        <div class="instagram-content col-lg-6">
          <div class='col-lg-10'>
            <h2 class="instagram-title">{{ mrte.instagramTitle }}</h2>
            <div class="instagram-text">{{mrte.instagramText}}</div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section>
    <div class="container req-section">
      <div class="row">
        <div @click="toggleClass" class="col-lg-12 mt-5" id="requirements" :aria-expanded="String(!isHidden)">
          <h2 class='req-section-pointer'>{{mrte.requirementsHeader}}</h2>
          <IconBase :variant="isHidden ? 'angle-down' : 'angle-up'" color="#173945" classes="arrow req-section-pointer" />
        </div>
        <div id="req" class="row requirements" v-if="!isHidden">
          <div class="col-lg-6 mt-5 text-left">
            <div v-html="mrte.requirementsLeftColumn"></div>
          </div>
          <div class="col-lg-6 mt-5 text-left">
            <div v-html="mrte.requirementsRightColumn"></div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <Footer />
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import Butter from 'buttercms';
import Footer from '@/components/Common/Footer.vue';
import Banner from '@/components/Common/Banner.vue';
import IconBase from '../components/Common/icons/index.vue';

export const butter = Butter('eb418357164849860c223876bb84811162582149');

@Component({
  components: {
    Footer,
    Banner,
    IconBase,
  },
  data() {
    return {
      isHidden: true,
      submitted: false,
      completed: false,
      page: {
        fields: {},
      },
      mrte: {
        altDescription: null,
        altDescLogoLeft: null,
        altDescLogoRight: null,
        bannerCredit: null,
        bannerLogo: null,
        backgroundImage: null,
        block1Title: null,
        block1Desc: null,
        block1Desc2: null,
        block2Title: null,
        block2Desc: null,
        block2Image: null,
        description: null,
        enterTitle: null,
        enterDesc: null,
        headline: null,
        homeIcons: [],
        instagramTitle: null,
        instagramText: null,
        logoLeft: null,
        logoLeftLink: null,
        logoRight: null,
        logoRightLink: null,
        requirementsHeader: null,
        requirementsLeftColumn: null,
        requirementsRightColumn: null,
        tripIcons: [],
        video: null,
      },
    };
  },
  mounted() {
    document.addEventListener('keyup', this.onKeyListener);
  },
  beforeUnmount() {
    document.removeEventListener('keyup', this.onKeyListener);
  },
  methods: {
    getPage() {
      butter.page.retrieve('*', 'most-relaxing-trip', { preview: `${process.env.VUE_APP_BUTTER_PREVIEW}` })
        .then((res) => {
          this.page = res.data.data;
          this.mrte.altDescription = this.page.fields.alt_description;
          this.mrte.altDescLogoLeft = this.page.fields.alt_desc_logo_left;
          this.mrte.altDescLogoRight = this.page.fields.alt_desc_logo_right;
          this.mrte.backgroundImage = this.page.fields.background_image;
          this.mrte.bannerId = this.page.fields.header_image;
          this.mrte.bannerCredit = this.page.fields.banner_credit;
          this.mrte.bannerLogo = this.page.fields.banner_logo;
          this.mrte.block1Title = this.page.fields.block_1_title;
          this.mrte.block1Desc = this.page.fields.block_1_desc;
          this.mrte.block1Desc2 = this.page.fields.block_1_desc_2;
          this.mrte.block2Title = this.page.fields.block_2_title;
          this.mrte.block2Desc = this.page.fields.block_2_desc;
          this.mrte.block2Image = this.page.fields.block_2_image;
          this.mrte.description = this.page.fields.description;
          this.mrte.enterTitle = this.page.fields.enter_title;
          this.mrte.enterDesc = this.page.fields.enter_desc;
          this.mrte.headline = this.page.fields.headline;
          this.mrte.homeIcons = this.page.fields.home_icons;
          this.mrte.instagramTitle = this.page.fields.instagram_title;
          this.mrte.instagramText = this.page.fields.instagram_text;
          this.mrte.logoLeft = this.page.fields.logo_left;
          this.mrte.logoLeftLink = this.page.fields.logo_left_link;
          this.mrte.logoRight = this.page.fields.logo_right;
          this.mrte.logoRightLink = this.page.fields.logo_right_link;
          this.mrte.requirementsHeader = this.page.fields.requirements_header;
          this.mrte.requirementsLeftColumn = this.page.fields.requirements_left_column;
          this.mrte.requirementsRightColumn = this.page.fields.requirements_right_column;
          this.mrte.tripIcons = this.page.fields.trip_icons;
          this.mrte.video = this.page.fields.video;
        }).catch((res) => {
          console.log(res);
        });
    },
    toggleClass() {
      this.isHidden = !this.isHidden;
    },
    expand() {
      this.isHidden = false;
    },
  },
  async created() {
    this.getPage();
  },
})
class MostRelaxingTrip extends Vue {}

export default MostRelaxingTrip;
</script>

<style lang="scss" scoped>
@import '~@ditdot-dev/vue-flow-form/dist/vue-flow-form.css';
@import '~@ditdot-dev/vue-flow-form/dist/vue-flow-form.theme-minimal.css';
.arrow {
  color: #173945;
  position: absolute;
  right: 50px;
  top: 10px;
  width: 25px;
}
.banner-image {
  background-position: 65% 60%;
  background-repeat: no-repeat;
  height: 500px;
  width: 100%;

  img {
    height: 100%;
    width: 100%;
  }
}
.banner-logo {
  margin: 0 auto;
  position: absolute;
  top: 250px;
  width: 100%;
  z-index: 2;
}
.banner-logo img {
  width: 270px;
}
.bg-arrow {
  background-image: url('/images/misc/path_2@2x.png');
  background-position: 92% 20%;
  background-repeat: no-repeat;
  background-size: 20%;
}
.bg-image {
  margin: 0 auto;
  width: 100%;
}
.video-container {
  width: 100%;
  height: auto;
  margin-left: 0%;
  margin-right: 0%;
}
.block-title {
  font-family: 'susa-bold';
  font-size: 60px;
  line-height: 76px;
  margin-top: 50px;
}
.block-desc {
  font-size: 25px;
  line-height: 37px;
}
.block-desc-2 {
  font-size: 22px;
  line-height: 32px;
}
.description {
  font-family: 'IdealSans-Book';
  font-size: 18px;
  height: 640px;
  line-height: 34px;
  margin: 0 auto;
  width: 320px;
}
.description-link {
  font-size: 16px!important;
  text-decoration: none;
}
.desktop { display: none; }
.enter {
  margin: 0 auto;
  padding-bottom: 25px;
  text-align: center;
  width: 340px;
}
.enter-title {
  font-size: 50px;
  font-family: 'klinicslabbold';
  line-height: 40px;
  margin-bottom: 20px;
}
.enter-desc {
  font-family: 'IdealSans-Book';
  font-size: 18px;
  line-height: 34px;
}
.headline {
  font-family: 'klinicslabbold';
  font-size: 40px;
  margin: 0 auto;
  width: 295px;
}
.icons {
  display: flex;
  flex-wrap: wrap;
  padding: 0;
}
.icon-box {
  display: flex;
  flex-direction: column;
  width: 50%;
}
.image-icon {
  margin: 0 auto;
  width: 142px;
}
.caption-icon {
  font-family: 'klinicslabbold';
  font-size: 20px;
  line-height: 24px;
  margin: 0 auto;
  text-align: center;
}
.instagram {
  height: 535px;
  margin: 120px 0 99px;
  padding: 0 0.4px 0 0px;
  background-color: #f7f6f1;
}
.instagram-content {
  margin: 0 auto;
  padding: 5px;
  text-align: center;
  width: 340px;
}
.instagram-title {
  font-family: 'klinicslabbold';
  font-size: 27px;
  line-height: 34px;
}
.instagram-text {
  font-family: 'IdealSans-Book';
  font-size: 21px;
  line-height: 31px;
}
.intro {
  background-image: url('/images/misc/shoe-prints@2x.png'), url('/images/misc/foot-prints@2x.png');
  background-position: (100% 25%), (0% 25%);
  background-repeat: no-repeat;
  background-size: 18%;
}
.logo {
  left: 0;
  margin-top: 30px;
  width: 160px;
}
.logo-left,
.logo-right {
  height: auto;
  margin: 0 20px;
  padding: 15px;
  width: 200px;
}
.req-section { margin-bottom: 50px; }
.req-section-pointer { cursor: pointer; }
.requirements { margin: 0 auto; }
.trip-home-detail { margin-top: 100px; }
.video-div {
  margin: 0 auto;
  width: 75%;
}
@media only screen and (min-width: 411px) {
  .bg-arrow {
    background-position: 92% 23%;
    background-size: 11%;
  }
}
@media only screen and (min-width: 540px) {
  .bg-arrow {
    background-position: 90% 32.5%;
    background-size: 13%;
  }
}
/* Landscape */
@media only screen and (min-width: 567px) and (min-height: 319px)  {
  .arrow { right: 220px; }
  .banner-logo { top: 255px; }
  .description { width: 535px; }
  .enter {
    padding: 25px;
    width: 450px;
  }
  .headline { width: 500px; }
  .instagram { height: 635px; }
  .instagram-content {
    margin: 0 auto;
    width: 425px;
  }
  .instagram-title {
    font-family: 'klinicslabbold';
    font-size: 27px;
    line-height: 34px;
  }
  .video-div { width: 60%; }
}
@media only screen and (min-width: 568px)  {
  .description { height: 380px; }
}

@media only screen and (min-width: 667px)  {
  .arrow { right: 140px;}
  .description { height: 380px; }
}

/* iPad */
@media only screen and (min-width: 768px)  {
  .arrow { right: 215px;}
  .bg-arrow {
    background-image: url('/images/misc/path_3@2x.png');
    background-position: 17% 82%;
    background-repeat: no-repeat;
    background-size: 20%;
  }
  .caption-icon { width: 100px; }
  .description { height: 380px; }
  .desktop {
    display: block;
    margin-top: 225px;
    width: 100%;
  }
  .hd-block-title { margin-top: 130px; }
  .home-details-arrow-2 {
    background-image: url('/images/misc/path_3@2x.png');
    background-position: 33% 100%;
    background-repeat: no-repeat;
    background-size: 28%;
    position: absolute;
    width: 535px;
    height: 345px;
    right: 0;
    transform: scaleX(-1) rotate(82deg);
  }
  .icon-box { width: 25%; }
  .image-icon { width: 115px; }
  .intro {
    background-size: 15%;
    background-position: 100% 100%, 0% 40%;
  }
  .logo { width: unset; }
  .logo-left,
  .logo-right {
    height: auto;
    margin: 0 0;
    padding: 15px;
    width: 142px;
  }
  .trip-details { margin-top: 130px; }
}

@media only screen and (min-width: 1024px)  {
  .arrow { right: 340px; }
  .bg-arrow {
    background-position: 42% 93%;
    background-size: 14%;
  }
  .bg-video { width: 80%; }
  .boot-step {
    background-image: url('/images/misc/shoe-prints@2x.png');
    background-position: (60% 130%);
    background-repeat: no-repeat;
    background-size: 80%;
    height: 200px;
    left: 12px;
    position: absolute;
    transform: scaleX(-1) rotate(-12deg);
    width: 200px;
  }
  .description-link { text-decoration: underline; }
  .enter {
    margin-top: 100px;
    width: 630px;
  }
  .foot-step {
    background-image: url('/images/misc/foot-prints@2x.png');
    background-position: (0% 25%);
    background-repeat: no-repeat;
    background-size: 76%;
    bottom: 0px;
    height: 200px;
    position: absolute;
    right: 80px;
    width: 200px;
  }
  .headline {
    font-size: 60px;
    width: 670px;
  }
  .home-details {
    margin-bottom: 0px;
    height: 790px;
  }
  .home-details-arrow-1 {
    background-image: url(/images/misc/path_4@2x.png);
    background-position: 25% -14%;
    background-repeat: no-repeat;
    background-size: 90%;
    width: 400px;
    height: 130px;
    position: absolute;
    transform: scaleX(-1) scaleY(-1) rotate(-27deg);
    bottom: 70px;
    right: 330px;
  }
  .home-details-arrow-2 {
    background-image: url('/images/misc/path_3@2x.png');
    background-position: 30% 60%;
    background-size: 25%;
    right: 194px;
    transform: scaleX(-1) rotate(80deg);
  }
  .instagram {
    height: 435px;
    margin: 0;
  }
  .instagram-content {
    margin: auto;
    padding: 65px;
  }
  .trip-details {
    margin-bottom: 130px;
    height: 790px;
  }
  .instagram-section { margin-top: 75px; }
  .trip-home-detail { position: relative; }
  .video-div {
    margin-right: 30px;
    padding: 68px 0;
  }
}

@media only screen and (min-width: 1200px)  {
  .bg-arrow {
    background-position: 44% 68%;
    background-size: 10%;
  }
  .bg-image {
    margin-top: 50px;
    width: 75%;
  }
  .boot-step {
    background-size: 70%;
    left: 70px;
  }
  .description {
    height: 275px;
    width: 800px
  }
  .enter { width: 930px; }
  .foot-step { background-size: 70%; }
  .home-details-arrow-1 {
    background-position: 26% 30%;
    bottom: 25px;
    right: 415px;
    transform: scaleX(-1) scaleY(-1) rotate(-21deg);
  }
  .home-details-arrow-2 {
    background-position: 30% 60%;
    height: 380px;
    right: 270px;
  }
  .instagram {
    height: 550px;
    margin: 0px 0px;
  }
  .intro {
    background-size: 12%;
    background-position: 100% 100%, 0% 40%;
  }
  .logo { margin: 0 auto; }
  .trip-details { margin-top: 0; }
  .video-div {
    margin-right: 100px;
    width: 45%;
  }
}

@media only screen and (min-width: 1366px)  {
  .arrow { right: 400px; }
  .banner-logo { top: 280px }
  .bg-arrow { background-position: 44% 60%; }
  .block-title { margin-top: 0px; }
  .desktop { margin-top: 75px; }
  .home-details-arrow-1 { bottom: 212px; }
  .home-details-arrow-2 { background-position: 0% 0%; }
  .instagram-section { margin-top: 0px; }
}

@media only screen and (min-width: 1680px)  {
  .description { width: 900px; }
  .headline { width: 716px; }
}

</style>
